import { gql, useMutation } from '@apollo/client';

import { GET_CURRENT_MEMBER } from 'src/hooks/accounts/get-current-member-account.hook';

export const SET_GANTT_TO_MEMBER = gql`
  mutation setGanttToMember($ganttId: String!) {
    setGanttToMember(ganttId: $ganttId) {
      _id
    }
  }
`;

export const useSetGanttToMember = () => {
  const [setGanttToMember] = useMutation(SET_GANTT_TO_MEMBER, {
    refetchQueries: [GET_CURRENT_MEMBER],
  });

  return setGanttToMember;
};
